import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function getFieldDisplayName(fieldName: string, displayNames: { [key: string]: string }): string {
  return displayNames[fieldName] || fieldName;
}

export function getErrorMessage(form: FormGroup, fieldName: string, displayNames: { [key: string]: string }): string | null {
  const control = form.get(fieldName);
  if (control && control.invalid && (control.dirty || control.touched)) {
    if (control.hasError('required')) {
      return `${getFieldDisplayName(fieldName, displayNames)} is required`;
    }
    if (control.hasError('maxlength')) {
      const maxLength = control.errors?.['maxlength'].requiredLength;
      return `${getFieldDisplayName(fieldName, displayNames)} cannot exceed ${maxLength} characters`;
    }
    if (control.hasError('min')) {
      const min = control.errors?.['min'].min;
      return `${getFieldDisplayName(fieldName, displayNames)} cannot be less than ${min}`;
    }
    if (control.hasError('max')) {
      const max = control.errors?.['max'].max;
      return `${getFieldDisplayName(fieldName, displayNames)} cannot be greater than ${max}`;
    }
    if (control.hasError('email')) {
      return `Please enter a valid email for ${getFieldDisplayName(fieldName, displayNames)}`;
    }
    if (control.hasError('whitespace')) {
      return `Please enter valid data`;
    }
  }
  return null;
}

// check for white spaces
export function noWhitespaceValidator(): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {
    return (control.value || '').trim().length ? null : { 'whitespace': true };       
  }
}

// check for Default value
export function notDefaultValue(): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {
    return control.value != undefined || control.value !== 'Default' ? null : { 'default': true };       
  }
}